import { useLocation } from "react-router-dom";
import Indicator from "src/components/layout/Indicator";
import Link from "src/components/Link";

interface NavItemProps {
	to: string;
	children?: any;
	icon?: string;
	className?: string;
	count: number;
	badge?: string;
}

const NavItem = ({
	children,
	to,
	icon,
	className,
	count,
	badge,
}: NavItemProps) => {
	const location = useLocation();
	const isActive = location.pathname.startsWith(to);
	return (
		<Link {...{ to }} className={`flex items-center gap-3 ${className}`}>
			{icon && (
				<div
					className={`w-12 h-12 transition-all flex justify-center items-center text-dark ${
						isActive ? "bg-primary" : ""
					} relative rounded-md`}
				>
					{count > 0 && (
						<Indicator
							style={{
								top: -6,
								right: -5,
							}}
							className="absolute"
						>
							{count}
						</Indicator>
					)}
					{badge && (
						<Indicator
							className="rounded-sm absolute px-5 uppercase"
							style={{
								top: -4,
								right: -18,
							}}
						>
							{badge}
						</Indicator>
					)}
					<i className={`${icon} ${isActive && "text-white"}`}></i>
					<div className="absolute left-0 right-0 bottom-1 flex justify-center items-center">
						<span
							className={`transition-all flex w-1 h-1 rounded-full bg-primary opacity-${
								isActive ? "100" : "0"
							}`}
						></span>
					</div>
				</div>
			)}
			<strong className={`font-bold ${isActive && "text-primary"}`}>
				{children}
			</strong>
		</Link>
	);
};

NavItem.defaultProps = {
	count: 0,
};

export default NavItem;
